import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { JobApplicationResource } from './JobApplication';
import { JobListingResource } from './JobListing';
import { Base, Collection } from 'active-resource';
import { EmployerResource } from 'util/resources/Employer';

/**
 * Relationship classes
 */
export class LocationAttributes {
  additional_address: string = null;
  address: string = null;
  administrativeAreaLevel1: string = null;
  administrativeAreaLevel2: string = null;
  capacity: number = null;
  email: string = null;
  id: string = null;
  lat: number = null;
  lng: number = null;
  name: string = null;
  neighborhood: string = null;
  phone_number: string = null;
  zip: string = null;
}

export class LocationBelongsTo {
  jobApplications: () => JobApplicationResource = () => new JobApplicationResource();
  jobListings: () => JobListingResource = () => new JobListingResource();
}

export class LocationHasOne {}

export class LocationHasMany {
  employers: () => Collection<EmployerResource> = () => new Collection<EmployerResource>();
}

/**
 * Utility interfaces
 */
export interface LocationMethods {}

export interface LocationInterface
  extends LocationAttributes,
    LocationBelongsTo,
    LocationHasMany,
    LocationType {}

type LocationType = GConstructor<LocationInterface>;

export interface LocationResource
  extends Base<LocationAttributes>,
    LocationInterface,
    LocationMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<LocationAttributes>({
    queryName: 'locations',
    className: 'Location',
    AttributesClass: LocationAttributes,
    BelongsToClasses: [
      {
        Klass: LocationBelongsTo,
      },
    ],
    HasManyClasses: [
      {
        Klass: LocationHasMany,
      },
    ],
  });

export const LocationResourceClass = <TBase extends LocationType>(BaseConstructor: TBase): TBase =>
  class extends BaseConstructor implements LocationMethods {};

export class LocationResource extends ClassExtender<LocationInterface>(
  BaseClass,
  LocationResourceClass,
) {}

/**
 * Resource instance
 */
export const Location = APILibrary.createResource<LocationResource>(LocationResource);
